import { Component, Host, h, Prop, Watch, Element, State } from '@stencil/core';
import { isMagnoliaEditingMode } from '../../helper';
import { readjustGroupedElements } from '../../global/utility/readjust-grouped-elements/readjust-grouped-elements';
import { observereGroupedElementsToReadjust } from '../../global/utility/observe-grouped-elements-to-readjust/observe-grouped-elements-to-readjust';

interface UiCmsContactChannelsBody {
  columns: string;
  headline: string;
  leadtext: string;
  isAlignButtons: boolean;
}

@Component({
  tag: 'ui-cms-contact-channels',
  styleUrls: { default: 'ui-cms-contact-channels.scss', editing: 'ui-cms-contact-channels.magnolia.scss' },
})
export class UiCmsContactChannels {
  @Element() el: HTMLElement;

  @Prop({ mutable: true }) body: UiCmsContactChannelsBody = {} as any;

  @Prop({ attribute: 'body' }) utilityBody: string;

  @Prop({ reflect: true }) componentWidth: number;

  @Prop() inverted: boolean;

  @State() columnsToDisplay = 1;

  initialColumns = 1;

  @Watch('utilityBody')
  bodyChangeHandler(newValue: string) {
    this.body = newValue ? JSON.parse(newValue) : this.body;
  }

  componentWillLoad() {
    this.bodyChangeHandler(this.utilityBody);
  }

  @Watch('componentWidth')
  onColumnsChange() {
    if (this.initialColumns > 2 && this.componentWidth >= 904) {
      this.columnsToDisplay = this.initialColumns;
      return;
    }

    this.columnsToDisplay = this.componentWidth > 670 ? 2 : 1;
  }

  componentDidLoad() {
    this.initialColumns = parseInt(this.body.columns, 10);
    this.columnsToDisplay = this.initialColumns;

    if (this.initialColumns !== 1) {
      this.componentWidth = this.el.offsetWidth;
      this.addResizeListener();
    }

    if (isMagnoliaEditingMode()) {
      const channels = [].slice.call(this.el.querySelectorAll('.channel'));
      const mglBars = [].slice.call(this.el.querySelectorAll('.mgnlEditorBar.component'));
      readjustGroupedElements(mglBars, channels);
      observereGroupedElementsToReadjust(this.el, channels);
    }
  }

  addResizeListener() {
    // const setRelevantComponent = debounce(this.onColumnsChange.bind(this), 200, false);

    window.addEventListener('resize', () => {
      this.componentWidth = this.el.offsetWidth;
    });
  }

  render() {
    return (
      <Host>
        <h4
          class={{
            'sd-headline': true,
            'sd-headline--inline': true,
            'sd-headline--size-3xl': true,
            'sd-headline--inverted': this.inverted,
          }}
        >
          <span innerHTML={this.body.headline}></span>
        </h4>
        <p
          class={{ copy: true, 'sd-paragraph': true, 'sd-paragraph--inverted': this.inverted }}
          innerHTML={this.body.leadtext}
        ></p>
        <div
          class={{
            wrapper: true,
            'buttons-aligned': this.body.isAlignButtons,
            [`column-count--${this.columnsToDisplay}`]: true,
          }}
        >
          <slot></slot>
        </div>
      </Host>
    );
  }
}
